// extracted by mini-css-extract-plugin
export default {"tools":"Tools_tools__LDqcW","tool":"Tools_tool__ivJBe"};